import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import {
  CognitoState,
  Login,
  NewPasswordRequired,
  EmailVerification,
  Confirm
} from 'react-cognito';
import queryString from 'query-string';
import LoginForm from './LoginForm';
import EmailVerificationForm from './EmailVerificationForm';
import NewPasswordRequiredForm from './NewPasswordRequiredForm';
import ConfirmForm from './ConfirmForm';
import './account.css';
import * as actions from '../../store/actions/index';
import AWS from 'aws-sdk';
import ConsoleLog from './../../hoc/ConsoleLog/ConsoleLog';
import axios from '../../services/axios-service';

/**
 * @desc Allow authenticated user to Dashboard
 * @param user, attributes, redirectUrl
 * @return null
 */
const loggedInPage = (user, attributes, redirectUrl) => (
  <Redirect to={redirectUrl} />
);
/**
 * @desc Exit loggedout user to Login Page
 * @param null
 * @return null
 */
const loggedOutPage = (props) => (
  <div className="login-main">
  {localStorage.removeItem('Progress')}
  <Login>
    <LoginForm {...props} />
  </Login>
  </div>
);
/**
 * @desc Set new password for specific user
 * @param null
 * @return null
 */
const newPasswordPage = (props) => (
  <div className="new-password-main">
    {/* <p className="text-center"></p> */}
    <NewPasswordRequired>
      <NewPasswordRequiredForm {...props} />
    </NewPasswordRequired>
  </div>
);
/**
 * @desc Shows message to inform user to check mail for verification
 * @param null
 * @return null
 */
const emailVerificationPage = () => (
  <div>
    <p>You must verify your email address.  Please check your email for a code</p>
    <EmailVerification>
      <EmailVerificationForm />
    </EmailVerification>
  </div>
);
/**
 * @desc Shows Confirmation Pop-up to send the verification mail to the user mail account
 * @param null
 * @return null
 */
const confirmForm = () => (
  <div>
    <p>A confirmation code has been sent to your email address</p>
    <Confirm>
      <ConfirmForm />
    </Confirm>
    <Link to="/">Home</Link>
  </div>
);

const mfaPage = () => (
  <div>
    <p>You need to enter an MFA, but this library does not yet support them.</p>
  </div>
);
/**
 * @desc Authentication of User based on the role and functionality according to cognito-state
 * @param state, user, attributes, groups, onGetClientDetails
 * @return null
 */
const BaseAccount = ({ location, state, user, attributes, groups, onGetClientDetails,onGetInterViewListCount }) => {
  switch (state) {
    case CognitoState.LOGGED_IN:
      
      if(!localStorage.getItem('firstLogin')){
        axios.post('/galaxy/user/activity',{ email: user.username, activity: "LOGIN"})
        .then(resp => {})
        .catch(err => ConsoleLog(err)); 
      }
      localStorage.removeItem('firstLogin');

      const urlArray = window.location.href.split('/');

      const accessingRole = (urlArray[3] === "recruiter") ? "Recruiter" : "Client";
      let redirectUrl = "/";
      if(groups.includes('admin')) {
        redirectUrl = "/admin/dashboard"; 
        onGetClientDetails(attributes['custom:userid'], false, user); 
        return loggedInPage(user, attributes, redirectUrl);
      } else if(groups.includes('recruiter')) {
        redirectUrl = "/recruiter/dashboard"; 
        onGetClientDetails(attributes['custom:userid'], false, user); 
        onGetInterViewListCount(attributes['custom:userid']);
        return loggedInPage(user, attributes, redirectUrl);
      } else if(groups.includes('client')) {
        redirectUrl = "/"; 
        onGetClientDetails(attributes['custom:userid'], true, user); 
        return loggedInPage(user, attributes, redirectUrl);
      } else {
        if(user) {
          ConsoleLog('user logged out');
          user.signOut();
          if (AWS.config.credentials) {
            AWS.config.credentials.clearCachedId(); // this is the clear session
            AWS.config.credentials = new AWS.CognitoIdentityCredentials({}); // this is the new instance after the clear
          }    
          localStorage.clear();
          return loggedOutPage('You are not authorised to login as ' + accessingRole +'. Please Contact Administrator!');
        }
      }
    case CognitoState.AUTHENTICATED:
    case CognitoState.LOGGING_IN:     
      return (
        <div className="progress-loader">
        
          {/* <LinearProgress className="progress-bar" /> */}
          {/* <img src={ajax_loader} alt="" /> */}
        </div>
        )
    case CognitoState.LOGGED_OUT: 
        localStorage.clear();
    case CognitoState.LOGIN_FAILURE:
      if (AWS.config.credentials) {
        AWS.config.credentials.clearCachedId(); // this is the clear session
        AWS.config.credentials = new AWS.CognitoIdentityCredentials({}); // this is the new instance after the clear
      }
      const jobTitleId = localStorage.getItem('jobTitleId');
      const interviewId = localStorage.getItem('interviewId');
      localStorage.clear();
      if(jobTitleId && jobTitleId !== "" && jobTitleId !== "null" && jobTitleId !== null) {
        localStorage.setItem('jobTitleId', jobTitleId);
      }
      if(interviewId && interviewId !== "" && interviewId !== "null" && interviewId !== null) {
        localStorage.setItem('interviewId', interviewId);
      }
      return loggedOutPage({ defaultUsername: queryString.parse(location.search).email });
    case CognitoState.MFA_REQUIRED:
      return mfaPage();
    case CognitoState.NEW_PASSWORD_REQUIRED:
      // axios.post('/galaxy/user/activity',{ email: user.username, activity: "FIRST_LOGIN"})
      // .then(resp => {})
      // .catch(err => ConsoleLog(err)); 
      return newPasswordPage({username: user.username});
    case CognitoState.EMAIL_VERIFICATION_REQUIRED:
      return emailVerificationPage();
    case CognitoState.CONFIRMATION_REQUIRED:
      return confirmForm();
    default:
      return (
        <div>
          <p>Unrecognised cognito state</p>
        </div>
      );
  }
};
BaseAccount.propTypes = {
  user: PropTypes.object,
  attributes: PropTypes.object,
  state: PropTypes.string,
};

const mapStateToProps = state => ({
  state: state.cognito.state,
  user: state.cognito.user,
  attributes: state.cognito.attributes,
  groups: state.cognito.groups,
  google_refresh_token : 1

});
/**
* @desc connecting to redux actions
* @param dispatch
* @return redux actions
*/
const mapDispatchToProps = dispatch => {
  return {
    onGetClientDetails: (clientId, isJobList, loggedInUser) => dispatch(actions.getClientDetails(clientId, isJobList, loggedInUser)),
    onGetInterViewListCount:(recruiterId)=>dispatch(actions.getInterViewListCount(recruiterId))
  }
}

const Account = connect(mapStateToProps, mapDispatchToProps)(BaseAccount);

export default Account;


// WEBPACK FOOTER //
// ./src/components/Authentication/Account.js